import { type Result, err, ok } from "neverthrow";

export const fetchFileFromUrl = async (
  url: string,
  fileName: string,
): Promise<Result<File, Error>> => {
  let blob: Blob;
  try {
    const response = await fetch(url);
    blob = await response.blob();
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : JSON.stringify(e);
    console.error(errorMessage);
    return err(
      new Error(`ファイルのダウンロードに失敗しました。 ${errorMessage}`),
    );
  }
  return ok(new File([blob], fileName));
};
